import { Messages } from "../../lib/locale";

export const Spanish: Messages = {
  name: "Español",
  helpTitle: "Como jugar",
  help1: `Cada día habrá un País Secreto. Tu objetivo es adivinar el país secreto en el menor número de intentos posibles. Cada respuesta incorrrecta aparecerá en el globo con un color indicando que tan cerca se encuentra del País Secreto. Entre más <b>caliente</b> sea el color, más cerca estarás de la respuesta.`,
  help2: `Por ejemplo, si el País Secreto es <b>Japón</b>, entonces los siguientes países aparecerían de los siguientes colores si fueran seleccionados:`,
  France: "Francia",
  Nepal: "Nepal",
  Mongolia: "Mongolia",
  "South Korea": "Corea del Sur",
  help3: `¡Un nuevo País Secreto estará disponible todos los días!`,
  Aux1: "¡Haz click en el globo para jugar!",
  Aux2: "¿Tienes alguna duda?",
  Aux3: "Visita Preguntas Frecuentes.",
  Footer1: "Creado por The Abe Train",
  Footer2: "¿Estas disfrutando el juego?",
  Footer3: "Cómprame un café!",
  Loading: "Cargando...",
  FAQTitle: "Preguntas Frecuentes",
  q1: "1. ¿Cómo se calcula la distancia entre mi intento y la respuesta correcta?",
  a1: "La distancia entre países se define como la mínima distancia entre sus fronteras.",
  q2: "2. ¿Cómo puedo jugar el juego si soy daltónico o si tengo una discapacidad visual?",
  a2: "Una modalidad de alto contraste puede ser activada en <button>Ajustes</button>.",
  q3: "3. ¿Cómo decide el juego que países son válidos?",
  a3: "Globle utiliza <a>este marco</a> para determinar que constituye un intento válido.",
  q4: "4. ¿Hay países autónomos no soberanos en el juego?",
  a4: "Algunos territorios aparecerán en un color neutral cuando su país soberano sea adivinado, por ejemplo. Groenlandia para Dinamarca. La ubicación de estos territorios no impacta el color del país soberano. La mayoría de los territorios pequeños no aparecen en el juego,  por ejemplo. Curazao.",
  q5: "5. ¡Encontré el país secreto de hoy! ¿Cuando puedo jugar otra vez?",
  a5: "El pais secreto cambia y tus intentos se reajustan a la media noche de tu zona horaria.",
  q6: "",
  a6: "",
  q7: "6. Hace falta un país o una frontera es incorrecta. ¿Qué puedo hacer al respecto?",
  a7: "La geografía puede ser un tema sensible, y las fronteras de algunos países pueden ser disputadas. Si tu crees que una corrección es necesaria, por favor de manera respetuosa plantea la cuestion con {GitHub} o enviame un MD en {Twitter}.",
  GameTitle: "Juego",
  Game1: "Ingresa el nombre del país aquí",
  Game2: "Ingresar",
  Game3: "Ingresa el nombre de cualquier pais para iniciar el juego.",
  Game4:
    "Arrastra, haz click, y zoom-in en el globo para ubicar tu siguiente país.",
  Game5: "Intento inválido",
  Game6: "Pais ya adivinado",
  Game7: "¡El País Secreto es {answer}!",
  Game8: "Frontera más cercana",
  StatsTitle: "Estadísticas",
  Stats1: "Última victoria	",
  Stats2: "Intentos de hoy",
  Stats3: "Victorias",
  Stats4: "Racha actual",
  Stats5: "Racha max",
  Stats6: "Promedio de intentos",
  Stats7: "Promedio de intentos",
  Stats8: "Reajustar",
  Stats9: "Compartir",
  Stats10: "¿Estás seguro de que quieres restablecer tu puntuación?",
  Stats11: "Estadísticas borradas.",
  Stats12: "Copiado",
  SettingsTitle: "Ajustes",
  Settings1: "Tema Diurno",
  Settings2: "Tema Nocturno",
  Settings3: "Modalidad de Alto Contraste Apagado",
  Settings4: "Modalidad de Alto Contraste Activado",
  Settings5: "Países",
  Settings6: "Ciudades",
  Settings7: "Idioma",
  Settings8: "Próximamente Globle Edición de Ciudades",
  Settings9: "Practicar",
  Settings10: "Arco iris activado",
  Settings11: "Arco iris desactivado",
  Answer: "Respuesta",
  Closest: "Los países más cercanos",
  Guessed: "Guessed", //TODO: Translate
  PracticeMode: "You are in practice mode.", //TODO: Translate
  PracticeExit: "Exit practice mode", //TODO: Translate
  PracticeNew: "New practice game", //TODO: Translate
  SortByGuesses: "Sort by order of guesses", //TODO: Translate
  SortByDistance: "Sort by distance", //TODO: Translate
};

// export default {
//   [LOCALES.Spanish]: esMessages,
// };
